<template>
    <div id="app" v-cloak>
        <MainPage v-show="showPage == 'main'" :language="language"></MainPage>
        <div class="pcWrap" v-show="showPage == 'pc'">
            <pcPage :language="language"></pcPage>
        </div>
    </div>
</template>

<script>
import { myHTTP } from './utils/net'
import { lang } from '@/tool/lang'
import MainPage from '@/pages/main'
import pcPage from '@/pages/pc'

import queryString from 'query-string'

import uaParser from 'ua-parser-js'
const ua = uaParser(navigator.userAgent)

let parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        MainPage,
        pcPage
    },
    data() {
        return {
            isShow: false,
            showPage: '',
            isQuit: false,
            giftCode: '',
            status: false,
            language: '',
            lang2: '',
            langarr: [{}]
        }
    },
    mounted() {
        if (parsed.clear) {
            localStorage.clear()
            let path = this.$route.path
            window.location = path
            this.showPage = 'main'
        }
        for (let i in lang) {
            this.langarr[0][i] = lang[i][this.language]
        }
    },
    created() {
        // 活动开放至 2026-08-03 23:59（北京时间），到期后禁止访问
        const expireAt = new Date('2026-08-03T23:59:59+08:00').getTime()
        if (Date.now() > expireAt) {
            alert('This link has expired.')
            window.close()
            return
        }

        this.getLanguage()
        this.init()

        let type = ua.device.type
        if (type == 'mobile') {
            this.showPage = 'main'
        } else {
            this.showPage = 'pc'
        }
    },
    methods: {
        init() {
            ;(function (doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight

                        if (!clientWidth) return
                        if (clientWidth < 1200) {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = 14 * (clientWidth / 1080) + 'px'
                            } else {
                                docEl.style.fontSize = 16 * (clientWidth / 1080) + 'px'
                            }
                            if (clientWidth > 1023) {
                                if (this.language === 'ja') {
                                    docEl.style.fontSize = '16px'
                                } else {
                                    docEl.style.fontSize = '16px'
                                }
                            }
                        } else {
                            if (this.language === 'ja') {
                                docEl.style.fontSize = '16px'
                            } else {
                                docEl.style.fontSize = '18px'
                            }
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
        },
        getLanguage() {
            var type = navigator.appName
            if (type == 'Netscape') {
                var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
            } else {
                var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
            }
            var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
            this.language = lang2
            if (lang2 === 'zh') {
                let zh = lang.substr(0, 5)
                this.language = zh
            }
            if (this.language === 'zh-cn') {
                this.language = 'zh-CN'
            }
            if (this.language === 'zh-tw') {
                this.language = 'zh-TW'
            }

            if (parsed.language) {
                this.language = parsed.language;
            }

            if (
                ['en', 'ar', 'fr', 'de', 'id', 'ja', 'ko', 'pt', 'ru', 'es', 'th', 'es', 'tr', 'vi', 'it', 'zh-CN', 'zh-TW'].indexOf(
                    this.language
                ) < 0
            ) {
                this.language = 'en'
            }
        },
    }
}
</script>

<style  lang="less">
[v-cloak] {
    display: none;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0 !important;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
#app {
    position: relative;
    margin: 0 auto;
    // max-width: 1024px !important;
    overflow: hidden;
    font-family: CookieRunBold;
    height: 100vh;
}
.pcWrap{
    width: 100%;
    height: 100%;
    background: url('./assets/img/1920x1080.png') 100% 100% no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;  
}
// .pcWrap::before{
//     content: '';
//     display: block;
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     top: 0;
//     right: 0;
//     bottom: 0;
//     left: 0;
//     background: url('./assets/img/1920x1080.png') 100% 100% no-repeat;
//     background-size: 100% 100%;
//     // opacity: 0.8;
// }

</style>




// WEBPACK FOOTER //
// src/App.vue